import { Default, Detail,  List, Create } from "./views";



const Module = {
    name: "pools",
    defaultRoutePath: "/cars/pool",
    menuItemScope: "fleet",
    menuItemName: "assignments",

    routes: [
        {
            path: "/cars/pool",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        }
    ],
    
}

export default Module;
